import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function requiredCheckboxValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return { requiredCheckbox: true };
    }
    return null;
  };
}
